import type { TextField } from '@payloadcms/plugin-form-builder/types'
import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@onclicks/sharedcomponents/ui/Input'
import { Label } from '@onclicks/sharedcomponents/ui/Label'
import React from 'react'

import { Error } from '@onclicks/sharedcomponents/FieldForm//Error'

export const Text: React.FC<
  TextField & {
    errors: Partial<FieldErrorsImpl>
    placeholder?: string
    register: UseFormRegister<FieldValues>
  }
> = ({ name, defaultValue, errors, label, placeholder, register, required }) => {
  return (
    <div className="flex flex-col gap-2">
      <Label htmlFor={name} className="text-primary font-bold">
        {label}

        {required && (
          <span className="required">
            * <span className="sr-only">(required)</span>
          </span>
        )}
      </Label>
      <div className="gradient-border rounded-full">
        <Input
          defaultValue={defaultValue}
          id={name}
          type="text"
          placeholder={placeholder}
          className="rounded-full border-0 bg-pink-200 text-primary placeholder:text-primary/60 focus-visible:ring-secondary/50 focus-visible:ring-offset-0"
          {...register(name, { required })}
        />
      </div>
      {errors[name] && <Error name={name} />}
    </div>
  )
}
